"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFeatureFlagOverride = exports.publishFeatureFlagOverrides = exports.getFlag = exports.getFeatureFlagOverrides = exports.createEnvironmentFlags = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _storage = require("../util/storage");
var _environment = _interopRequireDefault(require("../util/environment"));
var _navConstants = _interopRequireDefault(require("../constants/navConstants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // @ts-check
/** Where feature flag overrides get set in session storage */
var FEATURE_FLAG_OVERRIDES = 'zola_feature_flag_overrides';

/**
 * A featureFlag that can be on or off based on the environment.
 */

/**
 * A lookup of feature flags to overridden values;
 */

/**
 * A lookup of feature flags to EnvironmentFlags
 */

/**
 * Gets a lookup of feature flag overrides from session storage
 *
 * @memberof client
 *
 * @returns {EnvironmentFlagOverride} - Lookup of overriden feature flags.
 */
var getFeatureFlagOverrides = exports.getFeatureFlagOverrides = function getFeatureFlagOverrides() {
  try {
    return JSON.parse((0, _storage.getSessionStorage)(FEATURE_FLAG_OVERRIDES) || '') || {};
  } catch (_unused) {
    (0, _storage.deleteSessionStorage)(FEATURE_FLAG_OVERRIDES);
  }
  return {};
};

/**
 * Sets a feature flag override in session stroage
 *
 * @param {string} featureFlag - Name of the feature flag to override
 * @param {boolean} overrideValue - Value to set for the feature flag
 *
 * @memberof client
 * @returns {void}
 */
var setFeatureFlagOverride = exports.setFeatureFlagOverride = function setFeatureFlagOverride(featureFlag, overrideValue) {
  if (!featureFlag) return;
  var overrides = getFeatureFlagOverrides();
  overrides[featureFlag] = overrideValue;
  (0, _storage.setSessionStorage)(FEATURE_FLAG_OVERRIDES, JSON.stringify(overrides));
};

/**
 * Creates an feature flag with fields for each environment
 *
 * @param {boolean} development
 * @param {boolean} staging
 * @param {boolean} production
 *
 * @returns {EnvironmentFlag}
 */
var createEnvironmentFlags = exports.createEnvironmentFlags = function createEnvironmentFlags() {
  var development = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var staging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var production = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    development: development,
    staging: staging,
    production: production
  };
};
var environment = (0, _environment.default)();

/**
 * Gets the feature flag for the current environment.
 *
 * @param {FeatureFlags} flags - lookup of feature flags
 * @param {string} flag - flag to lookup
 *
 * @returns {boolean}
 */
var getFlag = exports.getFlag = function getFlag(flags, flag) {
  if (flags[flag]) {
    if (typeof window !== 'undefined') {
      var overriddenFlags = getFeatureFlagOverrides();
      if (overriddenFlags[flag] !== undefined) {
        return Boolean(overriddenFlags[flag]);
      }
    }
    return Boolean(flags[flag][environment]);
  }
  return false;
};
var FEATURE_FLAGS_AVAILABLE = _navConstants.default.EVENTS.FEATURE_FLAGS_AVAILABLE;

/**
 * Publishes a set of feature flags, making them available for overrides
 * using the zola-ui feature flags component.
 *
 * @param flags
 */
var publishFeatureFlagOverrides = exports.publishFeatureFlagOverrides = function publishFeatureFlagOverrides(productFeatureFlags, domain) {
  var flagSettings = Object.keys(productFeatureFlags).reduce(function (result, flag) {
    var flagSetting = _objectSpread({
      value: getFlag(productFeatureFlags, flag)
    }, productFeatureFlags[flag]);
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, flag, flagSetting));
  }, {});
  var featureFlagAvailablePayload = {
    domain: domain,
    flags: flagSettings
  };
  window.dispatchEvent(new CustomEvent(FEATURE_FLAGS_AVAILABLE, {
    detail: featureFlagAvailablePayload
  }));
};